module.exports = __webpack_public_path__ + "static/media/Brands_22.dc74999c.png";